(function () {
  'use strict';

  if (window.KnickerProductCart) return;

  function route(path) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + path;
  }

  async function request(path, options) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 15000);

    try {
      var response = await fetch(route(path), Object.assign({}, options, {
        signal: controller.signal,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      }));
      var data;
      try {
        data = await response.json();
      } catch (error) {
        if (response.ok) throw error;
      }
      if (!response.ok) {
        var failure = new Error('Cart request failed');
        failure.status = response.status;
        failure.data = data;
        throw failure;
      }
      return data;
    } finally {
      clearTimeout(timer);
    }
  }

  async function refreshCart(open) {
    var cart = await request('cart.js', { method: 'GET' });
    if (!cart || !Array.isArray(cart.items) || typeof cart.total_price !== 'number' || !Number.isFinite(cart.total_price) || cart.total_price < 0) throw new Error('Invalid cart response');
    if (window.cart_drawer && window.cart_drawer.$data) {
      if (typeof window.cart_drawer.apply_cart === 'function') {
        window.cart_drawer.apply_cart(cart);
      } else {
        window.cart_drawer.$data.cart_items = cart.items;
      }
      if (open) window.cart_drawer.$data.cart_open = true;
    }
  }

  window.KnickerProductCart = {
    submit: async function (product, properties) {
      if (product.loading) return;

      product.error = false;
      product.status = '';

      if (window.KnickerProductOptions && !window.KnickerProductOptions.requireSize(product)) return;

      if (!product.current_variant || !product.current_variant.available) {
        product.error = true;
        product.status = 'This option is sold out. Please choose another size or colour.';
        return;
      }

      var quantity = Number(product.quantity);
      if (!Number.isFinite(quantity) || quantity < 1 || Math.floor(quantity) !== quantity) {
        product.error = true;
        product.status = 'Please enter a whole quantity of 1 or more.';
        return;
      }

      var item = { id: product.current_variant.id, quantity: quantity };
      if (properties) item.properties = properties;
      product.loading = true;
      var added = false;

      try {
        await request('cart/add.js', { method: 'POST', body: JSON.stringify({ items: [item] }) });
        added = true;
        await refreshCart(true);
        product.status = 'Added to your bag.';
      } catch (error) {
        product.error = true;
        if (added) {
          product.status = 'Your item was added, but we couldn’t refresh your bag. View your bag to check it before adding again.';
        } else if (error.status === 422) {
          var description = error.data && error.data.description;
          product.status = (typeof description === 'string' && description.trim()
            ? description
            : 'That size or quantity isn’t available. Choose another size or reduce the quantity.')
            + ' Check your bag before adding again.';

          // A stock rejection can still add the remaining available quantity.
          try { await refreshCart(false); } catch (refreshError) { /* Keep the stock message. */ }
        } else if (error.status === 429) {
          product.status = 'Your bag is busy. Wait a moment, then check your bag before trying again.';
        } else {
          product.status = 'We couldn’t confirm whether the item was added. Check your bag before trying again.';
        }
      } finally {
        product.loading = false;
      }
    }
  };
})();
